import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import TrackChangesIcon from "@material-ui/icons/TrackChanges";
import { Game } from "../../types/game";
import { isRangeGame } from "../../utils/rhiGame";
import { RANGE_GAME_COLORS } from "./rangeGameStyles";

export type RangeGameBadgeVariant = "list" | "header" | "menu";

type Props = {
  game: Pick<Game, "isRangeGame" | "rangeHandicapMode" | "competition">;
  variant?: RangeGameBadgeVariant;
  className?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    flexShrink: 0,
    gap: 6,
    height: 22,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.01em",
    lineHeight: 1,
    color: RANGE_GAME_COLORS.badgeText,
    backgroundColor: RANGE_GAME_COLORS.badgeSurface,
    border: `1px solid ${RANGE_GAME_COLORS.badgeBorder}`,
    borderRadius: 100,
    boxSizing: "border-box",
    boxShadow: `inset 0 1px 0 rgba(255, 255, 255, 0.7), 0 1px 2px rgba(27, 94, 32, 0.06)`,
  },
  icon: {
    fontSize: 14,
    color: RANGE_GAME_COLORS.badgeDot,
    flexShrink: 0,
  },
  iconHeader: {
    fontSize: 15,
  },
  header: {
    height: 24,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: "0.8125rem",
  },
  menu: {
    height: 20,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: "0.6875rem",
    fontWeight: 600,
    gap: 4,
    letterSpacing: "0.03em",
    boxShadow: "none",
  },
  iconMenu: {
    fontSize: 12,
  },
}));

const RangeGameBadge = ({ game, variant = "list", className }: Props) => {
  const classes = useStyles();
  if (!isRangeGame(game)) return null;
  const badgeClass = [
    classes.badge,
    variant === "header" ? classes.header : "",
    variant === "menu" ? classes.menu : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const iconClass = [
    classes.icon,
    variant === "header" ? classes.iconHeader : "",
    variant === "menu" ? classes.iconMenu : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={badgeClass} aria-label="Range game">
      <TrackChangesIcon className={iconClass} aria-hidden />
      Range
    </span>
  );
};

export default RangeGameBadge;
